import { createFileRoute } from '@tanstack/react-router';

import { RequisitionsPage } from '@/features/procurement/requisitions-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/requisitions')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <RequisitionsPage {...params} />;
}
